import { useMutation } from '@apollo/client';
import { END_VACATION_MODE, USER } from '../userTypeDefs';

export const useMutationEndVacationMode = (options?: any): any =>
  useMutation(END_VACATION_MODE, {
    refetchQueries: [{ query: USER }],
    awaitRefetchQueries: true,
    ...options,
  });


